export const ChatIntelligenceEndpoints = {
  ChatHistory: (sectionId: string) =>
    `/v3/chatIntelligence/videoQuestion/section/${sectionId}`,
  AskQuestion: '/v3/chatIntelligence/videoQuestion',
  ConversationHistoryList: (queries: { page: string; search?: string }) =>
    `/v3/chatIntelligence/conversation?page=${queries.page}&search=${queries.search}`,
  SelectedConversation: (id: string) =>
    `/v3/chatIntelligence/conversation/${id}/chats`,
  Chat: '/v3/chatIntelligence/chat',
  Categories: '/v3/chatIntelligence/category',
  Level: '/v3/chatIntelligence/level'
} as const
